var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activityTemp"},[_c('keep-alive',{attrs:{"include":_vm.includeList}},[(_vm.user.providerstatus == 10)?_c('router-view'):_vm._e()],1),(_vm.user.providerstatus != 10)?_c('serviceProviderTip'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }